"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import Slider from "react-slick";
import Link from "next/link";
import { getApiBaseUrl } from "@/lib/apiBase";
const BASE_URL = getApiBaseUrl();

export default function Advices() {
  const [advices, setAdvices] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const settings = {
    dots: true,
    infinite: false,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    appendDots: (dots) => (
      <div
        style={{ position: "absolute", bottom: "-20px", width: "100%" }}
        className="flex justify-center"
      >
        <ul className="flex gap-2 p-0 m-0 list-none">{dots}</ul>
      </div>
    ),
    customPaging: () => (
      <div className="w-3 h-3 bg-gray-300 rounded-full hover:bg-[#577099] transition-all"></div>
    ),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  useEffect(() => {
    const fetchAdvices = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/api/advice?type=advice`);
        const data = await response.json();
        setAdvices(data);
      } catch (error) {
        console.error("Error fetching advices:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAdvices();
  }, []);

  if (loading) {
    return (
      <div className="max-w-[1440px] mx-auto py-8 px-4">
        <div className="h-10 bg-gray-200 rounded-lg animate-pulse w-48 mb-6"></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-[400px] bg-gray-200 rounded-xl animate-pulse"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-[1440px] mx-auto py-8 px-4">
    <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6 text-center md:text-left">
      Зөвлөгөө
    </h1>

    <div className="flex flex-col md:flex-row gap-4">
      <div className="relative w-full md:w-[100%] rounded-xl overflow-hidden">
        <Slider {...settings}>
          {advices?.length > 0 && advices.map((advice) => (
            <div key={advice.id} className="px-2">
              <Link href={`/advice/${advice.id}`} rel="noopener noreferrer">
                <div className="relative w-full h-[300px] md:h-[400px] overflow-hidden rounded-xl group cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-500">
                  {/* Event image */}
                  <Image
                    src={`${BASE_URL}${advice.image}`}
                    alt={advice.advice_title}
                    fill
                    className="object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                  />

                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-transparent via-black/30 to-black/80"></div>

                  {/* Date badge */}
                  <div className="absolute top-4 left-4 bg-[#577099] text-white text-xs px-3 py-1 rounded-full shadow-lg">
                    {new Date(advice.createdAt).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                    })}
                  </div>

                  {/* Text on image — now at bottom */}
                  <div className="absolute bottom-0 left-0 right-0 bg-black/60 text-white p-4 z-10">
                    <h3 className="text-xl md:text-lg font-bold drop-shadow-lg mb-1">
                      {advice.advice_title}
                    </h3>
                    <p className="text-sm opacity-80 line-clamp-2">
                      {advice.advice_content?.length > 100
                        ? `${advice.advice_content.substring(0, 100)}...`
                        : advice.advice_content}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  </div>

  );
}
